import React, { useState, useEffect, useMemo } from 'react';
import Input from '@lingxi-common-component/sirius-ui/Input';
import { Button } from 'antd';
import { getIn18Text, apiHolder, apis } from 'api';
import styles from './unlock.module.scss';
const systemApi = apiHolder.api.getSystemApi();
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const IntroUrl = `https://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac29830ec81fe715b2b`;
const Unlock = ({ content, unlockMail }) => {
    var _a, _b;
    const [encryptPassword, setEncryptPassword] = useState('');
    const [remark, setRemark] = useState({ show: false, text: '' });
    const [decrypting, setDecrypting] = useState(false);
    const isDecrypted = useMemo(() => {
        return content.isDecrypted;
    }, [content]);
    const showEncpwd = useMemo(() => {
        var _a, _b;
        return ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder) === 3 && ((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.encpwd);
    }, [content]);
    const checkRemark = () => {
        systemApi.openNewWindow(IntroUrl);
    };
    const changePw = (e) => {
        const { value } = e.target;
        setEncryptPassword(value);
    };
    const doDecryptMail = async () => {
        const { id, _account } = content;
        try {
            setDecrypting(true);
            const decryptRes = await mailApi.doGetDecryptedContent(id, encryptPassword, _account || '');
            setDecrypting(false);
            const { passed, errMsg, data } = decryptRes;
            if (!passed) {
                setRemark({ show: true, text: errMsg || getIn18Text('JIEMISHIBAI') });
                return;
            }
            setRemark({ show: false, text: '' });
            unlockMail && data && unlockMail(data);
        }
        catch (error) {
            setDecrypting(false);
            console.log('解密邮件失败', error);
            setRemark({ show: true, text: getIn18Text('JIEMISHIBAI') });
        }
    };
    const confirmPw = () => {
        setRemark({ show: false, text: '' });
        if (!/^[a-zA-Z0-9]{6,16}$/.test(encryptPassword)) {
            setRemark({ show: true, text: getIn18Text('MIMACUOWU，QCXSR') });
            return;
        }
        doDecryptMail();
    };
    useEffect(() => {
        setDecrypting(false);
        setEncryptPassword('');
        setRemark({ show: false, text: '' });
    }, [content === null || content === void 0 ? void 0 : content.id]);
    return (React.createElement(React.Fragment, null, !isDecrypted ? (React.createElement("div", { className: styles.locked },
        React.createElement("div", { className: styles.lockedTitle },
            React.createElement("span", { className: styles.encryptedMailText }, getIn18Text('JIAMIYOUJIAN')),
            getIn18Text('ZHESHIYIFENGJIAMYJ，SRFJRTGDMM，JKYDWZYJ')),
        React.createElement("div", { className: styles.lockedCont },
            React.createElement("div", { className: styles.enterArea },
                React.createElement("span", null,
                    getIn18Text('SHURUMIMA'),
                    "\uFF1A"),
                React.createElement(Input, { className: styles.pwInput, placeholder: getIn18Text('QINGSHURU6WEIMM'), maxLength: 16, value: encryptPassword, onChange: changePw }),
                React.createElement(Button, { className: styles.confPw, type: "primary", onClick: confirmPw, loading: decrypting }, getIn18Text('QUEDING'))),
            !!showEncpwd && (React.createElement("div", { className: styles.pwIs },
                getIn18Text('JIAMIYOUJIANMIMW'),
                "\uFF1A", (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 :
                _a.encpwd)),
            !!remark.show && React.createElement("p", { className: styles.pwRemark }, remark.text || ''),
            React.createElement("p", { className: styles.intro, style: { marginTop: '12px' } },
                "1\u3001",
                getIn18Text('NINKETONGGUODIANH、DXHZQTFSXFJRSQMM。')),
            React.createElement("p", { className: styles.intro },
                "2\u3001",
                React.createElement("span", { className: styles.introBlue, onClick: checkRemark }, getIn18Text('CHAKANWANGYIYOUXJMYJSYSM')))))) : (React.createElement("div", { className: styles.unlocked },
        !!showEncpwd && `${getIn18Text('JIAMIYOUJIANMIMW')}：${(_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.encpwd}`,
        " ",
        getIn18Text('YOUJIANYIJIESUO，YXSNJSHDYXNR'),
        "\uFF1A"))));
};
export default Unlock;
